<template lang="html">
  <div
    v-click-outside="hideCountryLanguageSwitch"
    class="locales-switcher"
    @mouseleave="hideCountryLanguageSwitch"
  >
    <Button
      type="bare"
      class="locales-switcher__button"
      data-test-id="locales-switcher"
      @click="showCountryLanguageSwitch = !showCountryLanguageSwitch"
    >
      <CurrentLanguage :country="country" :locale="locale" class="locales-switcher__text" />
      <ArrowDownIcon
        slot="after"
        class="locales-switcher__icon"
      />
    </Button>
    <transition name="dropdown">
      <Dropdown
        v-show="showCountryLanguageSwitch"
        :min-width="true"
        visible
        anchor="right"
      >
        <CountryLanguageSelector
          :countries="countries"
          class="locales-switcher__country-language"
          @select="hideCountryLanguageSwitch"
        />
      </Dropdown>
    </transition>
  </div>
</template>

<script>
import CurrentLanguage from 'beisheim/components/elements/current-language'
import CountryLanguageSelector from 'beisheim/components/elements/country-language-selector'
import Dropdown from 'beisheim/components/elements/dropdown'
import Button from 'beisheim/components/elements/button'
import ArrowDownIcon from 'beisheim/assets/images/icons/beisheim-stiftung-dropdown.svg'

export default {
  components: {
    CurrentLanguage,
    CountryLanguageSelector,
    Dropdown,
    Button,
    ArrowDownIcon
  },
  props: {
    countries: {
      type: Array,
      default: () => []
    },
    country: {
      type: Object,
      default: () => ({})
    },
    locale: {
      type: Object,
      default: () => ({})
    },
    locales: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showCountryLanguageSwitch: false
    }
  },
  methods: {
    hideCountryLanguageSwitch () {
      this.showCountryLanguageSwitch = false
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/scale';

  .locales-switcher {
    display: flex;
    align-items: center;
    position: relative;
  }

  .locales-switcher__button {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
  }

  .locales-switcher__text {
    @include font(-1);
  }

  .locales-switcher__icon {
    display: flex;
    align-items: center;
    width: 6px;
  }

  .locales-switcher__country-language {
    &:not(:last-child) {
      margin-bottom: scale(-1);
    }
  }
</style>
